export default "__VITE_ASSET__5a6f23c9__"